<div class="settings-container">
  <form [formGroup]="formGroup">
    <div class="model-container">
      <div class="section-title">
        <h4>Model</h4>
      </div>

      <div class="model-fields">
        <p-floatLabel>
          <input
            formControlName="modelName"
            pInputText
            id="modelName"
            name="modelName"
            type="text"
          />
          <label for="modelName">Model name</label>
          <cognos-validation-message
            [control]="formGroup.get('modelName')"
          ></cognos-validation-message>
        </p-floatLabel>

        <p-floatLabel>
          <p-inputnumber
            formControlName="modelTopK"
            id="modelTopK"
            name="modelTopK"
            pTooltip="Valor bajo, más precisión y menos diversidad. Valor alto, más
  diversidad y menos precisión."
            tooltipPosition="bottom"
            required
          />
          <label for="modelTopK">Top K</label>
          <cognos-validation-message
            [control]="formGroup.get('modelTopK')"
          ></cognos-validation-message>
        </p-floatLabel>

        <p-floatLabel>
          <p-inputnumber
            formControlName="modelTopP"
            mode="decimal"
            locale="en-US"
            [minFractionDigits]="1"
            id="modelTopP"
            name="modelTopP"
            pTooltip="Valor bajo, más focalizado y conservativo. Trabaja con el Top K."
            tooltipPosition="bottom"
            required
          />
          <label for="modelTopP">Top P</label>
          <cognos-validation-message
            [control]="formGroup.get('modelTopP')"
          ></cognos-validation-message>
        </p-floatLabel>

        <p-floatLabel>
          <p-inputnumber
            formControlName="temperature"
            id="temperature"
            name="temperature"
            pTooltip="Valor bajo, más realista y menos alucinaciones."
            tooltipPosition="bottom"
            required
          />
          <label for="temperature">Temperature</label>
          <cognos-validation-message
            [control]="formGroup.get('temperature')"
          ></cognos-validation-message>
        </p-floatLabel>
      </div>
    </div>

    <p-divider />

    <div class="retrieving-container">
      <div class="section-title">
        <h4>Retrieving</h4>
      </div>

      <div class="retrieving-fields">
        <p-floatLabel>
          <p-inputnumber
            formControlName="topK"
            id="topK"
            name="topK"
            pTooltip="Número de chunks en el contexto."
            tooltipPosition="bottom"
            required
          />
          <label for="topK">Top K</label>
          <cognos-validation-message
            [control]="formGroup.get('topK')"
          ></cognos-validation-message>
        </p-floatLabel>

        <p-floatLabel>
          <p-inputnumber
            formControlName="memoryMessages"
            id="memoryMessages"
            name="memoryMessages"
            pTooltip="Número de mensajes en la memoria."
            tooltipPosition="bottom"
            required
          />
          <label for="memoryMessages">Memory messages</label>
          <cognos-validation-message
            [control]="formGroup.get('memoryMessages')"
          ></cognos-validation-message>
        </p-floatLabel>
      </div>
    </div>

    <p-divider />

    <div class="prompt-container">
      <div class="section-title">
        <h4>Prompt</h4>
      </div>

      <div class="prompt-fields">
        <p-floatLabel>
          <textarea
            formControlName="prompt"
            pTextarea
            fluid
            rows="5"
            cols="30"
            id="prompt"
            name="prompt"
            required
            class="prompt-textarea"
          >
          </textarea>
          <label for="prompt">Prompt</label>
          <cognos-validation-message
            [control]="formGroup.get('prompt')"
          ></cognos-validation-message>
        </p-floatLabel>
      </div>
    </div>

    <div class="model-actions">
      <p-button
        label="Save model changes"
        raised
        icon="pi pi-save"
        [disabled]="!formGroup.dirty"
        (click)="onSaveClick()"
      ></p-button>
    </div>
  </form>
</div>
